<template>
    <v-row>
        <v-col lg="4" md="12">
            <v-select
                :items="hours"
                :label="labelHour"
                v-model="hour"
                @change="updateValue"
                outlined
                :disabled="isDisabledElemsOnStaff"
            ></v-select>
        </v-col>
        <v-col lg="4" md="12">
            <v-select
                :items="minutes"
                :label="labelMinute"
                v-model="minute"
                @change="updateValue"
                outlined
                :disabled="isDisabledElemsOnStaff"
            ></v-select>
        </v-col>
        <v-col lg="4" md="12">
            <v-select
                :items="meridians"
                :label="labelMeridian"
                v-model="meridian"
                @change="updateValue"
                outlined
                :disabled="isDisabledElemsOnStaff"
            ></v-select>
        </v-col>
    </v-row>
</template>


<script>
import moment from "moment";

export default {
    props: {
        labelHour: {
            type: String,
            default: 'Hour'
        },
        labelMinute: {
            type: String,
            default: 'Minute'
        },
        labelMeridian: {
            type: String,
            default: 'AM/PM'
        },
        hours: {
            type: Array,
            default: () => Array.from({length: 12}, (_, i) => {
                const hour = i + 1;
                return hour < 10 ? '0' + hour : hour.toString();
            }),
        },
        minutes: {
            type: Array,
            default: () => Array.from({length: 60}, (_, i) => (i < 10 ? '0' + i : i.toString())),
        },
        meridians: {
            type: Array,
            default: () => ['AM', 'PM']
        },
        defaultTime: {
            type: String,
            default: '12:00 AM'
        },
        isDisabledElemsOnStaff: Boolean,
    },

    data: () => {
        return {
            hour: '',
            minute: '',
            meridian: ''
        };
    },

    created() {
        if (this.defaultTime) {
            this.hour = moment(this.defaultTime, "hh:mm A").format("hh");
            this.minute = moment(this.defaultTime, "hh:mm A").format("mm");
            this.meridian = moment(this.defaultTime, "hh:mm A").format("A");
        }
        this.updateValue();
    },

    watch: {
        defaultTime: {
            handler(newValue) {
                if (newValue) {
                    this.hour = moment(newValue, "hh:mm A").format("hh");
                    this.minute = moment(newValue, "hh:mm A").format("mm");
                    this.meridian = moment(newValue, "hh:mm A").format("A");
                }
                this.updateValue();
            }
        }
    },

    methods: {
        updateValue() {
            let value = `${this.hour}:${this.minute} ${this.meridian}`;
            this.$emit('input', value);
        }
    }
};
</script>
